/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ForceDeleteSnapshotsRequest {
  /**
  * List of snapshot IDs to force delete
  */
  'snapshotIds': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "snapshotIds",
      "baseName": "snapshotIds",
      "type": "Array<string>",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return ForceDeleteSnapshotsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

